import { handleActions } from 'redux-actions';
import { followUpModalActions } from '../actions/followUpModal';
export const initialState = {
    ui: {
        isModalShown: false,
        queueSelection: false,
    },
    timestamp: null,
    csid: null,
};
export const { followUpModalOpen, followUpModalClose } = followUpModalActions;
const reducer = handleActions({
    // Show follow-up modal.
    [followUpModalOpen.toString()]: (state, action) => {
        const { csid, conversationQueueId, timestamp, queueSelection } = action.payload;
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isModalShown: true, queueSelection }), timestamp,
            csid,
            conversationQueueId });
    },
    // Hide follow-up modal.
    [followUpModalClose.toString()]: (state, action) => {
        return initialState;
    },
}, initialState);
export default reducer;
